import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Overlay, DismissButton } from '@react-aria/overlays';
import { mergeRefs } from '@react-aria/utils';
import '../Box/index.js';
import { useAriaPopover } from './hooks/useAriaPopover.js';
import { Box } from '../Box/Box.js';

// Internal Popover currently used in Select component
var AriaPopover = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    state = props.state;
  var _useAriaPopover = useAriaPopover(props),
    underlayProps = _useAriaPopover.underlayProps,
    popoverProps = _useAriaPopover.popoverProps,
    popoverRef = _useAriaPopover.popoverRef,
    transitionProps = _useAriaPopover.transitionProps,
    shouldRender = _useAriaPopover.shouldRender;
  return shouldRender ? /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Box, transitionProps, /*#__PURE__*/React.createElement("div", underlayProps), /*#__PURE__*/React.createElement("div", _extends({}, popoverProps, {
    ref: mergeRefs(popoverRef, ref)
  }), /*#__PURE__*/React.createElement(DismissButton, {
    onDismiss: state.close
  }), children, /*#__PURE__*/React.createElement(DismissButton, {
    onDismiss: state.close
  })))) : null;
}));

export { AriaPopover };
//# sourceMappingURL=AriaPopover.js.map
